module.exports = __webpack_public_path__ + "08af9876ed45f732876489b76f5d27e6.png";